import { Navigate, Route, Routes } from 'react-router-dom'
import BrowseExceptionsPage from './pages/BrowseExceptionsPage'
import TicketsPage from './pages/TicketsPage'
import CleanupPage from './pages/CleanupPage'

const ErrorTrackerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/error-tracker/browse" replace />} />
      <Route path="/browse" element={<BrowseExceptionsPage />} />
      <Route path="/tickets" element={<TicketsPage />} />
      <Route path="/cleanup" element={<CleanupPage />} />
      <Route path="*" element={<Navigate to="/error-tracker/browse" replace />} />
    </Routes>
  )
}

export default ErrorTrackerRoutes
